import { useState } from "react";

export const useUploadArquivos = (
  handleUpload: Function,
  cadastrar: Function
) => {
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const executarUpload = async () => {
    setIsLoading(true);
    setSuccessMessage(null);
    setErrorMessage(null);

    try {
      const arquivos = await handleUpload();

      if (arquivos && Array.isArray(arquivos)) {
        for (const arquivo of arquivos) {
          try {
            if (arquivo?.data) {
              const cadastro = await cadastrar(arquivo.data?.data?.arquivoId);
              if (cadastro) {
                setSuccessMessage(
                  "Arquivos de Autorização Incluídos com Sucesso"
                );
              } else {
                setErrorMessage(
                  "Não foi possível incluir os arquivos. Tente novamente!"
                );
              }
            } else {
              setErrorMessage(
                "Arquivo inválido. Não foi possível incluir os arquivos."
              );
            }
          } catch (error) {
            setErrorMessage("Erro ao cadastrar arquivo. Tente novamente!");
          }
        }
      } else {
        setErrorMessage("Nenhum arquivo válido encontrado.");
      }
    } catch (error) {
      setErrorMessage("Erro durante o upload dos arquivos.");
    } finally {
      setIsLoading(false);
    }
  };

  return { executarUpload, isLoading, successMessage, errorMessage };
};
